import { useContext } from 'react';

import { useDispatch } from 'react-redux';

import { AuthContext } from '../providers/AuthProvider';
import { LoginDatabaseContext } from '../providers/LoginDatabaseProvider';
import { setCreated } from '../slices/accountSlice';

function useResetLogin() {
  const { database } = useContext(LoginDatabaseContext);
  const { setAuthenticated } = useContext(AuthContext);
  const dispatch = useDispatch();

  // clear all data related to login & user's account
  async function resetLogin() {
    try {
      await database.userProfile.clear();
    } catch (err) {
      console.log(err);
    }
    sessionStorage.removeItem('authToken');
    dispatch(setCreated(false));
    setAuthenticated(false);
  }

  return resetLogin;
}

export default useResetLogin;
